import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'PromotionPage',
    component: () => import('@/PromotionPage')
  }
]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  base: process.env.VUE_APP_BASE_URL,
  routes
})

export default router